const Loading = ({ label = "Loading repositories..." }) => {
  return (
    <div className="loading-wrap" role="status" aria-live="polite">
      <span className="loading-spinner" />
      <p>{label}</p>
    </div>
  );
};

export default Loading;
